import { render, staticRenderFns } from "./SSOAutoLogin.vue?vue&type=template&id=785ead00"
import script from "./SSOAutoLogin.vue?vue&type=script&lang=js"
export * from "./SSOAutoLogin.vue?vue&type=script&lang=js"
import style0 from "./SSOAutoLogin.vue?vue&type=style&index=0&id=785ead00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports